import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  addOnBoardData,
  deleteOnBoardData,
  fetchOnBoardData,
  moveOnBoardData,
  updateOnBoardData,
} from "../thunks/onBoardThunks";

import type { OnBoardService } from "../../utils/types/onBoard";

interface OnBoardState {
  onBoardServices: {
      [key: string]: OnBoardService[] | undefined;
    } | null;
  loading: boolean;
  error: string | null;
}

const initialState: OnBoardState = {
  onBoardServices: null,
  loading: false,
  error: null,
};

const onBoardSlice = createSlice({
  name: "onBoard",
  initialState,
  reducers: {
    // clearOnBoard(state) {
    //   state.onBoardServices = [];
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOnBoardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOnBoardData.fulfilled, (state, action) => {
        state.loading = false;
        // state.onBoardServices = action.payload || [];
        const { payload } = action;

        const { jobId } = payload;
        if (!jobId) {
          state.error = "Invalid job ID";
          return;
        }

        if (!state.onBoardServices) {
          state.onBoardServices = {};
        }
        state.onBoardServices[jobId] = payload.data || [];
      })
      .addCase(fetchOnBoardData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(updateOnBoardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOnBoardData.fulfilled, (state, action) => {
        state.loading = false;
        // state.onBoardServices = state.onBoardServices.map((service) => {
        //   if (service.onBoardServiceId === action.payload?.onBoardServiceId) {
        //     return { ...service, ...action.payload?.data };
        //   }
        //   return service;
        // });
        const { payload } = action;
        if (!payload || !payload.jobId || !payload?.onBoardServiceId) {
          state.error = " Invalid job ID or onBoardServiceId";
          return;
        }

        if (!state.onBoardServices || !state.onBoardServices[payload.jobId]) {
          return;
        }

        if (state.onBoardServices[payload.jobId]) {
          state.onBoardServices[payload.jobId] = state.onBoardServices[
            payload.jobId
          ]?.map((service) => {
            if (service.onBoardServiceId === payload?.data?.onBoardServiceId) {
              return { ...service, ...action.payload?.data };
            }
            return service;
          });
        }
      })
      .addCase(updateOnBoardData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deleteOnBoardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteOnBoardData.fulfilled, (state, action) => {
        state.loading = false;
        // state.onBoardServices = state.onBoardServices.filter(
        //   (service) =>
        //     service.onBoardServiceId !== action.payload?.onBoardServiceId
        // );
        const { payload } = action;
        if (!payload || !payload.jobId || !payload?.onBoardServiceId) {
          state.error = " Invalid job ID or onBoardServiceId";
          return;
        }

        if (!state.onBoardServices || !state.onBoardServices[payload.jobId]) {
          return;
        }

        if (state.onBoardServices[payload.jobId]) {
          state.onBoardServices[payload.jobId] = state.onBoardServices[
            payload.jobId
          ]!.filter(
            (service) =>
              payload?.onBoardServiceId !== service.onBoardServiceId
          );
        }
      })
      .addCase(deleteOnBoardData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addOnBoardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addOnBoardData.fulfilled, (state, action) => {
        state.loading = false;
        // state.onBoardServices = [action.payload, ...state.onBoardServices];
        const { payload } = action;
        if (!payload) {
          return;
        }

        const jobId = payload?.jobId;
        if (!jobId) {
          state.error = "Invalid job ID in response";
          return;
        }

        if (!state.onBoardServices) {
          state.onBoardServices = {};
        }

        const existingDeliveries = state.onBoardServices[jobId] || [];
        state.onBoardServices[jobId] = [payload.data, ...existingDeliveries];
      })
      .addCase(addOnBoardData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(moveOnBoardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(moveOnBoardData.fulfilled, (state, action) => {
        state.loading = false;
        // state.onBoardServices = state.onBoardServices.filter(
        //   (service) => service.onBoardServiceId !== action.payload?.id
        // );
        const { payload } = action;
        if (!payload || !payload.jobId || !payload?.id) {
          state.error = " Invalid job ID or delivery vendor ID";
          return;
        }

        if (!state.onBoardServices || !state.onBoardServices[payload.jobId]) {
          return;
        }

        if (state.onBoardServices[payload.jobId]) {
          state.onBoardServices[payload.jobId] = state.onBoardServices[
            payload.jobId
          ]?.map((service) => {
            if (service.onBoardServiceId === payload?.id) {
              return { ...service, berthId: action.payload?.data.berthId };
            }
            return service;
          });
        }
      })
      .addCase(moveOnBoardData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
      addWebSocketCases(builder, "onBoard", "onBoardServices")
  },
});

// export const { clearOnBoard } = onBoardSlice.actions;
export default onBoardSlice.reducer;
